'use strict';

angular.module('nfseApp')
    .factory('RPSSearch', function ($resource) {
        return $resource('api/_search/rps/:query', {}, {
            'query': { method: 'GET', isArray: true},
            'queryComFiltros': {
                method: 'POST',
                url: 'api/buscar-rps-filtro',
                isArray: true
            },
        });
    });
